<dx-popup title="Expanded message info" [shading]="false" [dragEnabled]="false" [(visible)]="isExpandedMessageVisible" (onHiding)="hideExpandedMessageVisible" [height]="'auto'" [hideOnOutsideClick]="true">
	<ng-container *ngIf="isExpandedMessageSubject | async as content">
		{{ content }}
	</ng-container>
</dx-popup>

<app-shell-pretty-json-viewer #picklistcomponent [json]="adminInstanceLog.value"></app-shell-pretty-json-viewer>

<div class="container-scheduler">
	<div class="left-div">
		<fieldset style="background-color: white">
			<legend>Link log history</legend>

			<div *ngIf="companyTimezone$ | async as companyTimezone">
				<div *ngIf="jobDataSourceOData; else noDataTemplate">
					<dx-data-grid [dataSource]="jobDataSourceOData" [showBorders]="true" (onCellClick)="cellClicked($event)" [height]="630" [showColumnHeaders]="false" [remoteOperations]="true">
						<dxo-load-panel [enabled]="true"></dxo-load-panel>
						<dxo-pager [visible]="true" [showPageSizeSelector]="false" [showInfo]="false" [showNavigationButtons]="false">
						</dxo-pager>
						<dxo-scrolling mode="virtual"></dxo-scrolling>

						<dxi-column caption="Link logs" [width]="200" [allowFiltering]="false" [allowSorting]="false" cellTemplate="cellTemplate">
						</dxi-column>

						<dxi-column sortOrder="desc" dataField="creationDate" [width]="150" [visible]="false"></dxi-column>

						<dxi-column [visible]="isAdminSubject.value" caption="Admin insight" [width]="100" [allowFiltering]="false" [allowSorting]="false" cellTemplate="adminInsightTemplate">
						</dxi-column>

						<dxo-filter-row [visible]="true"></dxo-filter-row>
						<dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

						<div *dxTemplate="let data of 'cellTemplate'">
							<table class="cell-template-table">
								<tr>
									<th>Start Date</th>
									<td>{{ data.data.creationDate | timezoneDate : companyTimezone }}</td>
								</tr>
								<tr>
									<th>Succeeded</th>
									<td style="color: green">{{ data.data.totalSucceeded }}</td>
								</tr>
								<tr>
									<th>Failed</th>
									<td style="color: red">{{ data.data.totalFailed }}</td>
								</tr>
								<tr>
									<th style="border-bottom: 1px solid #ddd;">Duration</th>
									<td style="border-bottom: 1px solid #ddd;">
										{{ data.data.creationDate | timeDifference: data.data.completionDate }}
									</td>
								</tr>
							</table>
						</div>

						<div *dxTemplate="let data of 'adminInsightTemplate'">
							<button class="btn btn-primary btn-sm" (click)="adminAzureInstanceLogs(data.data.instanceId)">
								Admin info
							</button>
						</div>
					</dx-data-grid>
				</div>
			</div>

			<ng-template #noDataTemplate>
				<div style="text-align: center; padding: 20px;">
					<p>No data available</p>
				</div>
			</ng-template>
		</fieldset>
	</div>

	<div class="right-div">
		<div *ngIf="SelectedDataSource && entriesAvailable">
			<fieldset>
				<legend>Link logs</legend>

				<div *ngIf="tabsSubject | async as tabs">
					<al-tabs [tabInfo]="tabs" [selectedTab$]="selectedTab$"></al-tabs>
				</div>

				<dx-scroll-view [height]="600">
					<div style="padding-top: 15px;">

						<!-- ===================== -->
						<!-- ALL MODE               -->
						<!-- ===================== -->
						<ng-container *ngIf="!(singleModeSelectionSubject | async)">
							<ng-container *ngIf="LogTypPropertiesMapping | async as LogTypPropertiesMappings">
								<ng-container *ngFor="let propertyMapping of LogTypPropertiesMappings">

									<fieldset style="background-color: white">
										<ng-container [ngSwitch]="propertyMapping.LogType">
											<ng-container *ngSwitchCase="'1'">
												<legend>Success</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'2'">
												<legend>Fail</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'3'">
												<legend>Mismatch</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'4'">
												<legend>Error</legend>
											</ng-container>
										</ng-container>

										<dx-data-grid id="gridContainer" [dataSource]="propertyMapping.dataSource" [showBorders]="true" (onRowPrepared)="onRowPrepared($event)" width="100%">

											<dxo-filter-row [visible]="true"></dxo-filter-row>
											<dxo-selection mode="none"></dxo-selection>

											<dxi-column dataField="jobLogType" cellTemplate="iconCellTemplate" [width]="25" caption="" alignment="center" allowFiltering="false">
											</dxi-column>

											<div *dxTemplate="let cell of 'iconCellTemplate'">
												<div [ngSwitch]="cell.text">
													<i *ngSwitchCase="'1'" class="far fa-check success-color"></i>
													<i *ngSwitchCase="'2'" class="far fa-times failure-color"></i>
													<i *ngSwitchCase="'3'" class="far fa-exclamation warning-color"></i>
													<i *ngSwitchCase="'4'" class="far fa-times failure-color"></i>
													<i *ngSwitchDefault class="far fa-eye"></i>
												</div>
											</div>

											<dxi-column sortOrder="desc" width="130px" format="dd-MM-yyyy HH:mm:ss" dataType="date" dataField="creationDate">
											</dxi-column>

											<!-- Dynamic columns (render helpArticles specially) -->
											<ng-container *ngFor="let columnName of propertyMapping.properties">
												<ng-container *ngIf="columnName === 'helpArticles'; else normalColumnAll">
													<dxi-column [dataField]="columnName" caption="Help articles" cellTemplate="helpArticlesTemplate" [width]="'auto'" [minWidth]="160" [allowResizing]="false">
													</dxi-column>
												</ng-container>

												<ng-template #normalColumnAll>
													<ng-container *ngIf="isWideColumn(columnName); else normalNarrowAll">
														<dxi-column [dataField]="columnName"></dxi-column>
													</ng-container>
													<ng-template #normalNarrowAll>
														<dxi-column [dataField]="columnName" width="auto" [caption]="columnName"></dxi-column>
													</ng-template>
												</ng-template>
											</ng-container>

											<!-- Action buttons -->
											<dxi-column type="buttons" width="40px">
												<dxi-button hint="Expand message" icon="search" [onClick]="expandMessageButton"></dxi-button>
											</dxi-column>

											<!-- ✅ helpArticlesTemplate MUST be inside the grid -->
											<div *dxTemplate="let cell of 'helpArticlesTemplate'">
												<!-- Only show anything for Error rows -->
												<ng-container *ngIf="cell.data?.jobLogType == '4'; else empty">
													<ng-container *ngIf="hasAnyArticleIds(cell.value); else requestHelp">
														<div class="mp-cell">
															<div *ngFor="let ha of cell.value" class="mp-row">
																<button *ngIf="ha.articleIds?.length" type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="openIssueHelp(ha, cell.data?.message ?? cell.data?.description ?? null)">
																	View help articles
																</button>
															</div>
														</div>
													</ng-container>

													<ng-template #requestHelp>
														<button type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="requestHelpForRow(cell.data)">
															Request help for this error
														</button>
													</ng-template>
												</ng-container>

												<ng-template #empty>
													<!-- render nothing for non-errors -->
													<span style="display:none;"></span>
												</ng-template>
											</div>




										</dx-data-grid>

										<ng-container *ngIf="propertyMapping.LogType == '3'">
											<div style="font-size:12px">*: This difference is more than just a VAT difference, please check the invoice.
											</div>
											<div style="font-size:12px">**: The difference here is a VAT difference.
											</div>
										</ng-container>
									</fieldset>

								</ng-container>
							</ng-container>
						</ng-container>

						<!-- ===================== -->
						<!-- SINGLE MODE            -->
						<!-- ===================== -->
						<ng-container *ngIf="(singleModeSelectionSubject | async)">
							<fieldset style="background-color: white">
								<ng-container [ngSwitch]="SelectedLogType">
									<ng-container *ngSwitchCase="'1'">
										<legend>Success</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'2'">
										<legend>Fail</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'3'">
										<legend>Mismatch</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'4'">
										<legend>Error</legend>
									</ng-container>
								</ng-container>

								<dx-data-grid id="gridContainer" [dataSource]="SelectedDataSource" [showBorders]="true" (onRowPrepared)="onRowPrepared($event)" width="100%">

									<dxo-filter-row [visible]="true"></dxo-filter-row>
									<dxo-selection mode="none"></dxo-selection>

									<dxi-column dataField="jobLogType" cellTemplate="iconCellTemplate2" [width]="25" caption="" alignment="center" allowFiltering="false">
									</dxi-column>

									<div *dxTemplate="let cell of 'iconCellTemplate2'">
										<div [ngSwitch]="cell.text">
											<i *ngSwitchCase="'1'" class="far fa-check success-color"></i>
											<i *ngSwitchCase="'2'" class="far fa-times failure-color"></i>
											<i *ngSwitchCase="'3'" class="far fa-exclamation warning-color"></i>
											<i *ngSwitchCase="'4'" class="far fa-times failure-color"></i>
											<i *ngSwitchDefault class="far fa-eye"></i>
										</div>
									</div>

									<dxi-column sortOrder="desc" width="auto" format="dd-MM-yyyy HH:mm:ss" dataType="date" dataField="creationDate">
									</dxi-column>

									<!-- Dynamic columns (render helpArticles specially) -->
									<ng-container *ngFor="let columnName of SelectedProperties">
										<ng-container *ngIf="columnName === 'helpArticles'; else normalColumnSingle">
											<dxi-column [dataField]="columnName" caption="Help articles" cellTemplate="helpArticlesTemplate" [width]="'auto'" [minWidth]="160" [allowResizing]="false">
											</dxi-column>
										</ng-container>

										<ng-template #normalColumnSingle>
											<ng-container *ngIf="isWideColumn(columnName); else normalNarrowSingle">
												<dxi-column [dataField]="columnName"></dxi-column>
											</ng-container>
											<ng-template #normalNarrowSingle>
												<dxi-column [dataField]="columnName" width="auto" [caption]="columnName"></dxi-column>
											</ng-template>
										</ng-template>
									</ng-container>

									<!-- Action buttons -->
									<dxi-column type="buttons" width="40px">
										<dxi-button hint="Expand message" icon="search" [onClick]="expandMessageButton"></dxi-button>
									</dxi-column>

									<!-- ✅ helpArticlesTemplate MUST be inside the grid -->
									<div *dxTemplate="let cell of 'helpArticlesTemplate'">
										<!-- Only show anything for Error rows -->
										<ng-container *ngIf="cell.data?.jobLogType == '4'; else empty">
											<ng-container *ngIf="hasAnyArticleIds(cell.value); else requestHelp">
												<div class="mp-cell">
													<div *ngFor="let ha of cell.value" class="mp-row">
														<button *ngIf="ha.articleIds?.length" type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="openIssueHelp(ha, cell.data?.message ?? cell.data?.description ?? null)">
															View help articles
														</button>
													</div>
												</div>
											</ng-container>

											<ng-template #requestHelp>
												<button type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="requestHelpForRow(cell.data)">
													Request help for this error
												</button>
											</ng-template>
										</ng-container>

										<ng-template #empty>
											<!-- render nothing for non-errors -->
											<span style="display:none;"></span>
										</ng-template>
									</div>

								</dx-data-grid>

								<ng-container *ngIf="SelectedLogType == JobLogType.AmountMismatch">
									<div style="font-size:12px">*: This difference is more than just a VAT difference, please check the invoice.
									</div>
									<div style="font-size:12px">**: The difference here is a VAT difference.</div>
								</ng-container>
							</fieldset>
						</ng-container>

					</div>
				</dx-scroll-view>
			</fieldset>
		</div>

		<br />

		<div *ngIf="!entriesAvailable && hasLogBeenClicked">
			Link has been executed, but there was nothing to transfer
		</div>
	</div>
</div>

<al-freshdesk-help-modal #helpModal></al-freshdesk-help-modal>
<app-missing-article-feedback #missingArticleFeedback></app-missing-article-feedback>
